import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useNotification } from '../../../../../helpers/Notification';
import * as ROUTES from '../../../../../router/Routes';
import { LoadingWidget } from '../../../../../widgets';
import MenuCardWidget from '../../../../../widgets/MenuCard';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import { allActividadesAcademicasAction } from '../../../../academico/actividades_academicas/ActividadesAcademicasAction';
import {
  allActividadesExtrasAction,
  deleteActividadesExtrasAction,
  setActivoActividadesExtrasAction,
} from '../ActividadesExtrasAction';
import { PARAMS_ACTIVIDADES_EXTRAS } from '../ActividadesExtrasReducer';

const ListadoActividadesExtras = ({ setOpenModalForm }) => {
  let history = useHistory();
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const actividadesAcademicasStore = Redux.useSelector(
    (state) => state.actividadesAcademicas,
  );
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (
        actividadesAcademicasStore.all &&
        actividadesAcademicasStore.all.length === 0
      ) {
        await allActividadesAcademicasAction(dispatch, null);
      }

      const payload = {
        ...actividadesExtrasStore.params,
        idPlanEvaluacion: planEvaluacionStore.activo.id,
      };
      dispatch({ type: PARAMS_ACTIVIDADES_EXTRAS, payload });
      if (
        actividadesExtrasStore.all &&
        actividadesExtrasStore.all.length === 0
      ) {
        await allActividadesExtrasAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteActividadesExtrasAction(
      { dispatch, notify },
      actividadesExtrasStore.activo.id,
      actividadesExtrasStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <LoadingWidget
          isLoading={actividadesExtrasStore.loadingAll || loadingDelete}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Grid container spacing={2}>
          {actividadesExtrasStore.all.map((el) => {
            return (
              <Grid item md={6}>
                <Card sx={{ position: 'relative' }}>
                  <CardContent>
                    <Typography
                      align="center"
                      variant="body1"
                      color="text.secondary"
                      fontWeight="bold"
                    >
                      {el.tipo}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="h6"
                      fontWeight="bold"
                      component="div"
                      align="center"
                      sx={{ mb: 0 }}
                    >
                      {el.instrumento?.nombre ?? '-'}
                    </Typography>
                    <Typography
                      align="center"
                      variant="body1"
                      fontWeight="bold"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      {el.ponderacion} Pts
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Estudiantes asignados: </strong>{' '}
                      {el.estudiantes?.length ?? '0'}
                    </Typography>
                    {el.tipo === 'RECUPERACION' ? (
                      <Typography variant="body2" color="text.secondary">
                        <strong>Actividad remplazada: </strong>{' '}
                        {el.ptevaInstrumento?.instrumento?.nombre ?? '--'}
                      </Typography>
                    ) : (
                      <br />
                    )}
                    <MenuCardWidget
                      onEdit={() => {
                        setActivoActividadesExtrasAction(dispatch, el);
                        setOpenModalForm(true);
                      }}
                      onDelete={async () => {
                        setActivoActividadesExtrasAction(dispatch, el);
                        setOpenModalDelete(true);
                      }}
                    />
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={() => {
                        setActivoActividadesExtrasAction(dispatch, el);
                        history.push(ROUTES.panelActividadExtra.to);
                      }}
                    >
                      ABRIR PANEL
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      {actividadesExtrasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {actividadesExtrasStore.activo.instrumento.nombre} (
            {actividadesExtrasStore.activo.tipo})
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoActividadesExtras;
